"use client";
import React from 'react';

const chevron = (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const inputCls =
  "border border-[#E6E9F0] rounded-lg h-12 px-4 text-base placeholder-[#98A2B3] bg-white transition-all focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/20 outline-none w-full";

const labelCls = "font-semibold text-[#232B38] text-[14px] md:text-[15px]";

const QuoteFormSection = () => {
  return (
    <section className="w-full">
      <div className="mb-8 text-center">
        <h1 className="text-[32px] sm:text-[44px] font-bold text-[#112140] mb-2 leading-tight">
          Request Your Custom Quote
        </h1>
        <p className="text-[18px] text-[#475467] font-normal">
          Already know your label requirements? Share your details and we'll send you a tailored estimate fast.
        </p>
      </div>

      <form className="bg-[#F7F9FC] rounded-[20px] shadow-[0_12px_28px_rgba(16,24,40,0.08)] p-6 sm:p-8 md:p-10 flex flex-col gap-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">

          {/* 1. Name */}
          <div className="flex flex-col gap-1">
            <label htmlFor="fullName" className={labelCls}>
              Name <span className="text-red-500">*</span>
            </label>
            <input
              id="fullName"
              type="text"
              required
              placeholder="Your full name"
              className={inputCls}
            />
          </div>

          {/* 2. Email */}
          <div className="flex flex-col gap-1">
            <label htmlFor="email" className={labelCls}>
              Email <span className="text-red-500">*</span>
            </label>
            <input
              id="email"
              type="email"
              required
              placeholder="your@email.com"
              className={inputCls}
            />
          </div>

          {/* 3. Phone */}
          <div className="flex flex-col gap-1">
            <label htmlFor="phone" className={labelCls}>
              Phone <span className="text-red-500">*</span>
            </label>
            <div className="flex gap-2">
              <select className="border border-[#E6E9F0] rounded-lg h-12 px-2 text-base w-[100px] bg-white appearance-none text-center cursor-pointer hover:border-[#C9A84C] transition-colors outline-none focus:border-[#C9A84C]">
                <option value="+91">🇮🇳 +91</option>
                <option value="+1">🇺🇸 +1</option>
                <option value="+44">🇬🇧 +44</option>
                <option value="+971">🇦🇪 +971</option>
                <option value="+61">🇦🇺 +61</option>
                <option value="+1">🇨🇦 +1</option>
                <option value="+49">🇩🇪 +49</option>
                <option value="+33">🇫🇷 +33</option>
                <option value="+65">🇸🇬 +65</option>
                <option value="+81">🇯🇵 +81</option>
              </select>
              <input
                id="phone"
                type="tel"
                required
                placeholder="000 000 0000"
                className="border border-[#E6E9F0] rounded-lg h-12 px-4 text-base flex-1 placeholder-[#98A2B3] bg-white transition-all focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/20 outline-none"
              />
            </div>
          </div>

          {/* 4. Material */}
          <div className="flex flex-col gap-1">
            <label htmlFor="material" className={labelCls}>
              Material <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="material"
                required
                defaultValue=""
                className="border border-[#E6E9F0] rounded-lg h-12 px-4 text-base bg-white w-full appearance-none text-[#101828] outline-none transition-all focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/20"
              >
                <option value="" disabled>Select material type</option>
                <option>Paper</option>
                <option>BOPP Film</option>
                <option>PVC Film</option>
                <option>Vinyl</option>
                <option>Metallic / Foil</option>
                <option>Thermal</option>
                <option>Other</option>
              </select>
              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#7D8CA4]">
                {chevron}
              </span>
            </div>
          </div>

          {/* 5. Quantity */}
          <div className="flex flex-col gap-1">
            <label htmlFor="quantity" className={labelCls}>
              Quantity <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="quantity"
                required
                defaultValue=""
                className="border border-[#E6E9F0] rounded-lg h-12 px-4 text-base bg-white w-full appearance-none text-[#101828] outline-none transition-all focus:border-[#C9A84C] focus:ring-2 focus:ring-[#C9A84C]/20"
              >
                <option value="" disabled>Select quantity range</option>
                <option>1 – 1,000</option>
                <option>1,000 – 2,000</option>
                <option>2,000 – 5,000</option>
                <option>5,000 – 10,000</option>
                <option>10,000 – 20,000</option>
                <option>20,000 – 50,000</option>
                <option>50,000+</option>
              </select>
              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[#7D8CA4]">
                {chevron}
              </span>
            </div>
          </div>

          {/* 6. Company Name (Optional) */}
          <div className="flex flex-col gap-1">
            <label htmlFor="company" className={labelCls}>
              Company Name{' '}
              <span className="text-[#98A2B3] font-normal text-[13px]">(Optional)</span>
            </label>
            <input
              id="company"
              type="text"
              placeholder="Your company name"
              className={inputCls}
            />
          </div>

        </div>

        <button
          type="submit"
          className="w-full sm:w-[340px] md:w-[360px] self-center bg-[#112140] hover:bg-[#0F1A34] text-white font-semibold py-4 rounded-full text-[18px] transition-all duration-300 mt-2 shadow-[0_4px_14px_rgba(17,33,64,0.39)] hover:shadow-[0_6px_20px_rgba(17,33,64,0.23)] active:scale-[0.98]"
        >
          Get a Quote
        </button>
      </form>
    </section>
  );
};

export default QuoteFormSection;
